// Tier pill — a richly-coloured chip used in list rows, detail heros, and
// the sticky preview card. Each tier gets its own metallic gradient so the
// visual weight matches the economic value of the tier.

import type { MembershipTier } from './types';
import { formatTierLabel, tierGradient } from './format';

export interface MembershipTierPillProps {
  tier: MembershipTier;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function MembershipTierPill({ tier, size = 'sm', className = '' }: MembershipTierPillProps) {
  const sizeCls =
    size === 'lg'
      ? 'px-3.5 py-1.5 text-xs'
      : size === 'md'
        ? 'px-3 py-1 text-[11px]'
        : 'px-2.5 py-0.5 text-[10px]';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r ${tierGradient(tier)} ${sizeCls} font-bold uppercase tracking-wider text-white shadow-sm ring-1 ring-white/20 ${className}`.trim()}
    >
      <svg
        className="h-3 w-3 drop-shadow"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        {/* Crown glyph — distinct from the Loyalty star and Voucher tag. */}
        <path d="M2.5 6.5l3 2.5 4.5-5 4.5 5 3-2.5L16 15H4L2.5 6.5z" />
      </svg>
      {formatTierLabel(tier)}
    </span>
  );
}
